function PreviousArrowIcon() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='9'
      height='17'
      fill='none'
      viewBox='0 0 9 17'
      className='viewer-icon'
    >
      <path
        fill='#06F'
        d='M8 16.5a.997.997 0 01-.707-.293l-7-7a.999.999 0 010-1.414l7-7a.999.999 0 111.414 1.414L2.414 8.5l6.293 6.293A.999.999 0 018 16.5z'
      />
    </svg>
  );
}

export default PreviousArrowIcon;
